import { useI18n } from "../../../i18n";
import { AiChat } from "../../../components/common/AiChat";

export default function StaffAssistant() {
  const { t } = useI18n();
  return (
    <div className="space-y-4" data-testid="staff-assistant-page">
      <h1 className="text-2xl font-bold text-navy sm:text-3xl">{t("ai.staffTitle")}</h1>
      <p className="text-sm text-slate-500">{t("ai.staffSub")}</p>
      <AiChat path="/ai/staff/ask" sessionKey="staff" suggestions={[t("ai.st1"), t("ai.st2"), t("ai.st3")]} testId="ai-staff" />
    </div>
  );
}
